<template>
  <j-modal :width="width" :visible="visible" @cancel="handleCancel" :footer="null">
    <div slot="title" style="font-weight: bold">{{ title }}</div>
    <a-carousel ref="carouselRef" arrows autoplay>
      <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px; z-index: 1">
        <a-icon type="left-circle" />
      </div>
      <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
        <a-icon type="right-circle" />
      </div>
      <div v-for="(url, index) in urlList" style="width: 90%" :key="index">
        <img :src="url" alt="" style="width: 100%; height: 550px; object-fit: contain" />
      </div>
    </a-carousel>
  </j-modal>
</template>

<script>
import { postAction, putAction, uploadAction } from '@/api/manage'

export default {
  name: 'RichTextModal',
  data() {
    return {
      title: '查看图片',
      width: '900px',
      visible: false,
      currUrl: '',
      urlList: [],
    }
  },
  methods: {
    async show(url, index, urlList) {
      this.visible = true
      this.currUrl = url
      this.urlList = urlList
      await this.$nextTick()
      console.log('实例', this.$refs.carouselRef)
      this.$refs.carouselRef.goTo(index) // 切换到指定的面板
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.ant-carousel >>> .slick-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 600px;
  line-height: 160px;
  overflow: hidden;
}

.ant-carousel >>> .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #acacac;
}
.ant-carousel >>> .custom-slick-arrow:before {
  display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
  opacity: 0.5;
}
.ant-carousel >>> .slick-dots button {
  background: #757575;
}
.ant-carousel >>> .slick-dots .slick-active button {
  background: rgb(88, 173, 243);
}
</style>
